/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { BrowserStorage } from '@zcode/storage'
import { ONE_DAY } from '@zcode/utils'

let storage: BrowserStorage | undefined

export const getOrCreateStorage = () => {
  if (!storage) {
    storage = new BrowserStorage({
      name: 'nzr',
      ttl: ONE_DAY * 60,
      maxSize: 1, // we'll use one key for this feature
    })
  }
  return storage
}
